import { useEffect } from 'react'

// Hook to enable smooth scrolling for the entire document temporarily
// We could remove it by applying it to the html directly in globals.css, but we may not
// want this all the time.
export default function useSmoothScroll() {
  useEffect(() => {
    const originalScrollBehavior = document.documentElement.style.scrollBehavior
    document.documentElement.style.scrollBehavior = 'smooth'

    return () => {
      document.documentElement.style.scrollBehavior = originalScrollBehavior
    }
  }, [])
}
